// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"style_headerWrapper__3sM5A","mainActionsWrapper":"style_mainActionsWrapper__Qiwdr","label":"style_label__1_NTe"};